export default __webpack_public_path__ + "static/media/cancer2.058acc1e.jpg";